import axios from 'axios'
import { REACT_APP_API_ROOT_URL, REACT_APP_PAGESIZE, REACT_APP_BASE_COIN_SYMBOL } from './constants/config'
const client = axios.create()
client.defaults.baseURL = REACT_APP_API_ROOT_URL
//client.defaults.baseURL = 'http://localhost:3000'
client.defaults.headers.post['Content-Type'] = 'application/json'
client.defaults.headers.post['Accept'] = 'application/json'
export let token = null
let tradingLabel = 'RXR/BTC';
let chartFilter = '1hour'

client.interceptors.request.use(config => {
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, err => {
  return Promise.reject(err)
})
const pageSize = REACT_APP_PAGESIZE;
const responseData = res => res.data
const paging = (pagesize, pageindex) => `pagesize=${pagesize}&pageindex=${pageindex}`;
const requests = {
  del: url => {
    return client.delete(url).then(responseData)
  },
  get: url =>
    client.get(url).then(responseData),
  put: (url, body) =>
    client.put(url, body).then(responseData),
  post: (url, body) =>
    client.post(url, body).then(responseData),
}
const Auth = {
  current: () =>
    requests.get('/users'),
  login: (email, password) =>
    requests.post('/users/login', JSON.stringify({ email, password })),
  verifyUserInfo: (firstname, lastname, phone, email, password, referrer, type) =>
    requests.post('/users/register/verify', JSON.stringify({ firstname, lastname, phone, email, password, referrer, type })),
  register: (firstname, lastname, phone, email, password, referrer, code, type) =>
    requests.post('/users', JSON.stringify({ firstname, lastname, phone, email, password, referrer, code, type })),
  forgotPassword: (email) =>
    requests.post(`/users/forgotpassword`, JSON.stringify({ email })),
  resetPassword: (email, code, password) =>
    requests.post(`/users/resetpassword`, JSON.stringify({ email, code, password })),
  getPinCode: (mobile, type, userkey) =>
    requests.post(`/users/pincode/get`, JSON.stringify({ mobile, type, userkey })),
  verifyPinCode: (userKey, code, type) =>
    requests.post(`/users/${userKey}/pincode/verify`, JSON.stringify({ code, type })),
  verifyUserPin: (userKey, pin) =>
    requests.post(`/users/${userKey}/pin/verify`, JSON.stringify({ pin })),
  verifyPassword: (userKey, password) =>
    requests.post(`/users/${userKey}/password/verify`, JSON.stringify({ password })),
  refreshTokenVersion: (userKey) =>
    requests.post(`/users/${userKey}/tokenversion/refresh`),
  getIds: (userKey) =>
    requests.get(`/users/${userKey}/ids`),
};
const Asset = {
  create: (name, description, data, category) => requests.post(`/assets`, { name, description, data, category }),
  update: (key, name, description, data, category) => requests.put(`/assets/${key}`, { name, description, data, category }),
  getAsset: (key) => requests.get(`/assets/${key}`),
  getAssets: () => requests.get(`/assets`),
  tokenizes: (key, symbol, name, description, legals) => requests.post(`/assets/${key}`, JSON.stringify(symbol, name, description, legals)),
}
const Accounts = {
  list: (userkey) => requests.get(`/accounts/user/${userkey}`),
  detail: (key, pageindex) => requests.get(`/accounts/${key}?${paging(pageSize, pageindex)}`),
  getAccount: (symbol) => requests.get(`/accounts/${symbol}/detail`),
  getUserKeyByExternal: (externalKey) => requests.get(`/accounts/external/${externalKey}`),
  withdraw: (account_key, amount, linkedbankJson = '') => {
    return requests.post(`/accounts/${account_key}/withdraw`, { amount: amount, linkedbank: linkedbankJson })
  },
  withdrawEth: (account_key, amount, address, notes, mode, code) => {
    return requests.post(`/accounts/${account_key}/withdraweth`, { amount: amount, address: address, notes: notes, mode: mode, code: code })
  },
  withdrawBtc: (account_key, amount, address, notes, mode, code) => {
    return requests.post(`/accounts/${account_key}/withdrawbtc`, { amount: amount, address: address, notes: notes, mode: mode, code: code })
  },
  withdrawErc20: (account_key, amount, address, notes, code) => {
    return requests.post(`/accounts/${account_key}/withdrawerc20`, { amount: amount, address: address, notes: notes, code: code })
  },
  deposit: (account_key, amount, type, card_name, card_number, card_expiry_month, card_expiry_year, card_ccv) => {
    let requestObj = null
    if (type === 'STOREDCARD') {
      requestObj = JSON.stringify({ amount, type })
    } else {
      requestObj = JSON.stringify({ amount, type, card_name, card_number, card_expiry_month, card_expiry_year, card_ccv })
    }
    return requests.post(`/accounts/${account_key}/depositstripe`, requestObj)
  },
  loadBankReferenceByExternal: (external) =>
    requests.get(`/accounts/external/${external}/bankreference`),
  getUserPrimeAccounts: (user_key) => requests.get(`/accounts/prime/user/${user_key}`),
  subscribe: (type, card_token, amount, plan) =>
    requests.post(`/accounts/subscribe`, { type, card_token, amount, plan })
}
const Transaction = {
  send: (sender_account, recipient_account, amount) =>
    requests.post(`/transactions/send`, JSON.stringify({ sender_account, recipient_account, amount })),
  sendViaAddress: (sender_address, recipient_address, amount, notes, code) =>
    requests.post(`/transactions/sendviaaddress`, JSON.stringify({ sender_address, recipient_address, amount, notes, code })),
  // detail: (transactionId, code) => requests.get(`/transactions/detail/${transactionId}/${code}`),
  detail: (accountkey, transactionId) => requests.get(`/transactions/${accountkey}/${transactionId}`),
  getTransferFee: () => requests.get(`/transactions/fee`),
  getTransFees: () => requests.get(`/transactions/fees/all`),
}
const Profile = {
  updateBankInfo: (userKey, swiftCode, accountName, accountNumber, bankAddress, bankName, countryCode, currencyCode) =>
    requests.put(`/users/${userKey}/bank/update`, { linkedbank: JSON.stringify({ swiftCode, accountName, accountNumber, bankAddress, bankName, countryCode, currencyCode }) }),
  verifyBankInfo: (userKey, amount1, amount2, verifyCode) =>
    requests.post(`/users/${userKey}/bank/verify`, JSON.stringify({ amount1, amount2, verifyCode })),
  getBankInfo: (userKey) =>
    requests.get(`/users/${userKey}/bank`),
  getProfile: (userkey) => requests.get(`/users/${userkey}`),
  updateProfile: (userkey, firstname, lastname, email) =>
    requests.post(`/users/${userkey}`, JSON.stringify({ firstname, lastname, email })),
  changePassword: (userkey, password) =>
    requests.post(`/users/${userkey}/password/update`, JSON.stringify({ password })),
  changeAvatar: (userkey, avatar) => {
    let formData = new FormData()
    // let tempArrary = avatar.uri.split('/');
    // let fileName = tempArrary[tempArrary.length - 1];
    // let file = { uri: avatar.uri, type: 'multipart/form-data', name: fileName }
    formData.append('file', avatar)
    return requests.post(`/users/${userkey}/avatar/update`, formData)
  },
  uploadId: (userkey, type, name, number, expiry, address, image) => {
    let formData = new FormData()
    if (image) {
      // let tempArrary = image.name.split('/');
      // let fileName = tempArrary[tempArrary.length - 1];
      // let file = { size: image.size, type: 'multipart/form-data', name: fileName }
      formData.append('file', image)
    }
    formData.append('type', type)
    formData.append('name', name)
    formData.append('number', number)
    formData.append('address', address)
    formData.append('expiry', expiry)

    return requests.post(`/users/${userkey}/uploadid`, formData)
  },
  removeLinkedCard: (userKey) =>
    requests.post(`/users/${userKey}/linkedcard/remove`),
  changePhone: (userkey, phone, code) =>
    requests.post(`/users/${userkey}/phone/update`, JSON.stringify({ phone, code })),
  sendVerificationEmail: (userkey) =>
    requests.post(`/users/${userkey}/emailcode/send`),
  updatePin: (userkey, pin) =>
    requests.post(`/users/${userkey}/pin/update`, JSON.stringify({ pin })),
  updateSecurity: (userkey, type, login_enabled, trade_enabled, withdraw_enabled, code) =>
    requests.post(`/users/${userkey}/security`, JSON.stringify({ type, login_enabled, trade_enabled, withdraw_enabled, code })),
  updateNotifications: (userkey, notification_newcoin, notification_trade, notification_bank_withdraw) =>
    requests.post(`/users/${userkey}/notifications`, JSON.stringify({ notification_newcoin, notification_trade, notification_bank_withdraw })),
  getSecurityEvents: () =>
    requests.get(`/users/security/events`),
  getTotp: (userkey) =>
    requests.get(`/users/security/totp/${userkey}`),
  setTotp: (userkey, token1, token2) =>
    requests.post(`/users/security/totp/${userkey}`, JSON.stringify({ token1, token2 })),
  setSecurityQuestions: (questions) =>
    requests.post(`/users/security/questions`, { security_questions: questions }),
  getSecurityQuestions: (email) =>
    requests.get(`/users/security/questions?email=${encodeURIComponent(email)}`),
  answerSecurityQuestions: (email, questions) =>
    requests.put(`/users/security/questions`, { email: email, security_questions: questions }),
  updateFavePair: (tradingpair, favourite) =>
    requests.post(`/users/favouritepair/update`, JSON.stringify({ tradingpair, favourite })),
  getFeeRate: (userkey, tradeType) =>
    requests.get(`/users/${userkey}/feerate?trade_type=${tradeType}`),
}
const Trades = {
  listByUser: (userkey, pageindex) => requests.get(`/trades/user/${userkey}?${paging(pageSize, pageindex)}`),
  listByUserV2: (userkey, status, tradepair, datefrom, dateto, pageindex) => {
    return requests.get(`/v2/trades/user/${userkey}?status=${status}&tradepair=${tradepair}&datefrom=${datefrom}&dateto=${dateto}&${paging(pageSize, pageindex)}`)
  },
  create: (userkey, type, currency, trade_currency, amount, price, market_price, code, currencyType) =>
    requests.post(`/trades`, JSON.stringify({ userkey, type, currency, amount, price, market_price, trade_currency, code, currencyType })),
  close: (key) => requests.post(`/trades/close`, JSON.stringify({ key })),
  detail: (key) => requests.get(`/trades/detail/${key}`),
  getMarket: (symbol) => requests.get(`/trades/market/${symbol}/info`),
  getMarketDepth: (symbol) => requests.get(`/trades/graph/${symbol}/depth`),
  getOrders: (symbol, mode) => requests.get(`/trades/market/orders/${symbol}/${mode}`),
  getMarketGraph: (symbol, interval) => requests.get(`/trades/graph/candle/v3/${symbol}/${interval}`),
  getMarketPrice: (symbol) => requests.get(`/trades/market/${symbol}/price`),
  // commit: (amount, symbol) => requests.post(`/trades/commit`, JSON.stringify({ amount, symbol })),
  commit: (currency, trade_currency, amount) => requests.post(`/trades/commit`, JSON.stringify({ currency, trade_currency, amount })),
  // getEstimateFee: (userkey, symbol, amount) => requests.post(`/trades/commit/estimatefee`, JSON.stringify({ userkey, symbol, amount })),
  getEstimateFee: (symbol, amount) => requests.get(`/trades/estimatefee?symbol=${symbol}&amount=${amount}`),
  getRate: (tradingPair) => requests.get(`/rates/${tradingPair}`),
  getRateLogs: (tradingPair) => requests.get(`/rates/${tradingPair}/logs`)
}
const Common = {
  getCurrentTradingLabel: () => {
    return tradingLabel
  },
  getChartFilter: () => {
    return chartFilter
  },
  getEtherenum: () => {
    return axios.get('https://api.coinmarketcap.com/v1/ticker/ethereum/').then(responseData)
  },
  getBitcoin: () => {
    return axios.get('https://api.coinmarketcap.com/v1/ticker/bitcoin/').then(responseData)
  },
  getPrimeTransactionStats: () => requests.get(`/coin/transactions/prime/stats`),
  getPrimeAccountList: () => requests.get(`/coin/accounts/prime/list`),
  getWallet: (publickey) => requests.get(`/coin/${publickey}`),
  getTokens: () => requests.get(`/tokens`),
  getToken: (symbol) => requests.get(`/tokens/${symbol}`),
  getConfigs: () => requests.get(`/configs`)
}
const News = {
  create: (title, summary, type, image, content) => {
    let formData = new FormData()
    if (image) {
      formData.append('image', image)
    }
    // if (icon) {
    //   formData.append('icon', icon)
    // }
    // if (button) {
    //   formData.append('button', button)
    // }
    // if (background) {
    //   formData.append('background', background)
    // }
    formData.append('title', title)
    formData.append('summary', summary)
    formData.append('type', type)
    formData.append('content', content)
    return requests.post(`/news`, formData)
  },
  update: (key, title, summary, type, image, content) => {
    let formData = new FormData()
    if (image) {
      formData.append('image', image)
    }
    // if (icon) {
    //   formData.append('icon', icon)
    // }
    // if (button) {
    //   formData.append('button', button)
    // }
    // if (background) {
    //   formData.append('background', background)
    // }
    formData.append('title', title)
    formData.append('summary', summary)
    formData.append('type', type)
    formData.append('content', content)
    return requests.put(`/news/detail/${key}`, formData)
  },
  getNews: (key) => requests.get(`/news/detail/${key}`),
  getList: () => requests.get(`/news/list`),
  deleteNews: (key) => requests.del(`/news/detail/${key}`),
}
const Certificates = {
  createCertificate: (type, name, description, criteria, recipientName, recipientEmail, commenced, completed) => requests.post(`/certificates`, { type, name, description, criteria, recipient_name: recipientName, recipient_email: recipientEmail, commenced, completed }),
  getCertificate: (key) => requests.get(`/certificates/${key}`),
  getCertificates: () => requests.get(`/certificates`),
  updateCertificateViews: (key) => requests.get(`/certificates/${key}/view`),
  getIssuer: (key) => requests.get(`/certificates/issuers/${key}`),
  getIssuerLogs: (key, page) => requests.get(`/certificates/issuers/${key}/logs?${paging(pageSize, page)}`),
  updateIssuer: (key, name, url, email) => requests.put(`/certificates/issuers/${key}`, { name, url, email }),
  uploadCertificates: (file) => {
    let formData = new FormData()
    formData.append('file', file)
    return requests.post(`/certifications/upload`, formData)
  },
  getPendingCertificates: () => requests.get(`/certifications/pending`),
  deletePendingCertificates: (key) => requests.del(`/certifications/pending/${key}`),
  bulkCreateCertificates: () => requests.post(`/certifications/pending`),
}
const Files = {
  upload: (file, directory, groups) => {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('directory', directory)
    formData.append('groups', groups)
    return requests.post(`/files`, formData)
  },
  removeFile: (key) => requests.del(`/files/${key}`),
  getFileDetail: (key) => requests.get(`/files/${key}`),
  getFileAndIncreaseView: (key) => requests.get(`/files/${key}/view`),
  // getFiles: () => requests.get(`/files`),
  downloadFile: (key) => requests.get(`/files/download/${key}`),
  updateFileGroups: (key, groups) => requests.post(`/files/${key}/groups`, { groups }),

  getDirectorySimple: (key) => requests.get(`/directories/${key}/simple`),
  getRootDirectory: () => requests.get(`/directories/root`),
  getDirectoryDetail: (key) => requests.get(`/directories/${key}`),
  createDirectory: (name, parent) => requests.post(`/directories`, { name, parent }),
  updateDirectory: (key, name) => requests.put(`/directories/${key}`, { name }),
  removeDirectory: (key) => requests.del(`/directories/${key}`),
  getDirectoryLogs: (key, page) => requests.get(`/directories/${key}/logs?${paging(pageSize, page)}`),
  getFlatDirectories: () => requests.get(`/directories`),
  getFileLogs: (key, page) => requests.get(`/files/${key}/logs?${paging(pageSize, page)}`),
  getAllLogs: (page) => requests.get(`/files/logs/all?${paging(pageSize, page)}`),
  getGroups: () => requests.get(`/groups`),
  getGroup: (key) => requests.get(`/groups/${key}`),
  createGroup: (name) => requests.post(`/groups`, { name }),
  updateGroup: (key, name) => requests.put(`/groups/${key}`, { name }),
  removeGroup: (key) => requests.del(`/groups/${key}`),
  getGroupSimpleList: () => requests.get(`/groups/simple`),
  assignUserToGroup: (key, email) => requests.post(`/groups/${key}/users`, { email }),
  removeUserFromGroup: (key, userkey) => requests.put(`/groups/${key}/users`, { userkey }),
}
const Logs = {
  all: (page) =>
    requests.get(`/logs/list?${paging(pageSize, page)}`),
}
export default {
  Auth,
  Common,
  Asset,
  Accounts,
  Transaction,
  Profile,
  Trades,
  News,
  Certificates,
  Files,
  Logs,
  setToken: _token => { token = _token },
  setTradingLabel: _tradingLabel => { tradingLabel = _tradingLabel },
  setChartFilter: _chartFilter => { chartFilter = _chartFilter }
}
